import React, { createContext, useContext, useEffect, useState } from 'react';
import { es, Translation } from '../data/translations.es';
import { en } from '../data/translations.en';
export type Lang = 'es' | 'en';
const dictionaries: Record<Lang, Translation> = {
  es,
  en
};
type LanguageContextValue = {
  lang: Lang;
  setLang: (lang: Lang) => void;
  toggleLang: () => void;
  t: Translation;
};
const LanguageContext = createContext<LanguageContextValue | null>(null);
const STORAGE_KEY = 'ase-lang';

// Spanish is the main language. English only shows if the visitor
// switches to it during the current visit.
function getInitialLang(): Lang {
  if (typeof window === 'undefined') return 'es';
  const stored = window.sessionStorage.getItem(STORAGE_KEY);
  return stored === 'en' ? 'en' : 'es';
}
type Props = {
  children: React.ReactNode;
};
export function LanguageProvider({
  children
}: Props) {
  const [lang, setLang] = useState<Lang>(getInitialLang);
  useEffect(() => {
    window.sessionStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const toggleLang = () => setLang(current => current === 'es' ? 'en' : 'es');
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    toggleLang,
    t: dictionaries[lang]
  }} data-id="element-596" data-mp="3cvo78jqc5uo3">
      {children}
    </LanguageContext.Provider>;
}
export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLang must be used within a LanguageProvider');
  }
  return ctx;
}